import { render, staticRenderFns } from "./addmultipleSR.vue?vue&type=template&id=6e90154d&"
import script from "./addmultipleSR.vue?vue&type=script&lang=js&"
export * from "./addmultipleSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports